// extracted by mini-css-extract-plugin
module.exports = {"root":"Qualiphy_root__12Bh4","boxTitle":"Qualiphy_boxTitle__2oqli","box":"Qualiphy_box__1-V2v","toggleWrap":"Qualiphy_toggleWrap__1M-Nf"};